module.exports = __webpack_public_path__ + "static/fitness-tab-app-plp-42955580c9f914f9b22b8c3890beaddd.png";